import * as React from 'react';
import { FC, useContext, useState } from 'react';
type Responsive = {
    steps: string[];
};

export const ResponsiveContext = React.createContext<Responsive>({} as never);

type ResponsiveProviderProps = {
    mediaQueries: { [key: string]: string }
};
export const ResponsiveProvider: FC<ResponsiveProviderProps> = ({ mediaQueries, children }) => {

    const [steps, setSteps] = useState<Responsive['steps']>([]);

    const onResize = () => {
        setSteps(Object.keys(mediaQueries)
            .filter(
                m => window.matchMedia(mediaQueries[m].replace("@media ", "")).matches
            )
        );
    }
    React.useEffect(() => {
        onResize();
        window.addEventListener("resize", onResize);
        return () => {
            window.removeEventListener("resize", onResize);
        }
    }, [])
    return (
        <ResponsiveContext.Provider value={{ steps }}>
            {children}
        </ResponsiveContext.Provider>
    );
}
export const Responsive: FC<{ steps: string[] }> = ({ steps, children }) => {
    const { steps: CurrentSteps } = useResponsive();
    if (steps.filter(x => CurrentSteps.includes(x)).length) {
        return <>{children}</>;
    }
    return null;
}
export const useResponsive = () => useContext(ResponsiveContext);


// WEBPACK FOOTER //
// ./src/@context/Responsive.tsx